import { useState } from 'react'
import axios from 'axios'
import { useAuth } from '../../modules/auth'
import { toast } from 'react-toastify'

const useApiService = () => {
  const [error, setError] = useState(null)
  const [isFetching, setIsFetching] = useState(true)
  const [isFetchingAgain, setIsFetchingAgain] = useState(false)
  const [loading, setLoading] = useState(false)

  const { logout, saveAuth, setCurrentUser } = useAuth()

  // Tokeni al
  const localStorageData: any = localStorage.getItem('kt-auth-react-v')
  const localStorageJSON = JSON.parse(localStorageData)

  const access_token = localStorageJSON.access_token


  // Lokalden URL'i al
  const server_url = localStorageJSON.server_url

  // Dili al
  const lang: any = localStorage.getItem('i18nConfig')
  const langJSON = JSON.parse(lang)

  // Url'i al
  const api = axios.create({
    baseURL: server_url,
  })
  const handleRequest = async (request: any) => {
    try {
      setLoading(true)
      setIsFetchingAgain(true)
      const response = await request()
      if (response.status === 200) {
        //200 ise data return
        setLoading(false)
        setIsFetching(false)
        setIsFetchingAgain(false)
        if (response.data.is_success === true) {
          return response.data
        } else {
          // validator_errors varsa tüm errorları toast içinde göster
          response.data.validator_errors &&
            Object.keys(response.data.validator_errors).forEach((key) => {
              const errorsForField = response.data.validator_errors[key]
              errorsForField.forEach((error: any) => {
                toast.error(error)
              })
            })
          response.data.message && toast.error(response.data.message)
          return response.data
        }
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        setIsFetching(false)
        setIsFetchingAgain(false)
        setLoading(false)
        saveAuth(undefined)
        localStorage.removeItem('selectedLocation')
        setCurrentUser(undefined)
      } else {
        setIsFetching(false)
        setIsFetchingAgain(false)
        setLoading(false)
        setError(error.message)
        console.error('API isteği sırasında bir hata oluştu:', error)
      }
    }
  }
  const get = async (url: any, data?: any, header?: any) => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
      'app-language': `${langJSON.selectedLang}`,
      ...(header || {}), // Eğer header varsa, bu satır ile eklenir
    }

    return handleRequest(() => api.post(url, data, { headers }))
  }

  const post = async (url: any, data?: any, header?: any) => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
      'app-language': `${langJSON.selectedLang}`,
      ...(header || {}), // Eğer header varsa, bu satır ile eklenir
    }

    return handleRequest(() => api.post(url, data, { headers }))
  }

  const put = async (url: any, data?: any, header?: any) => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
      'app-language': `${langJSON.selectedLang}`,
      ...(header || {}), // Eğer header varsa, bu satır ile eklenir
    }

    return handleRequest(() => api.put(url, data, { headers }))
  }
  const deleteRequest = async (url: any, data?: any, header?: any) => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
      'app-language': `${langJSON.selectedLang}`,
      ...(header || {}), // Eğer header varsa, bu satır ile eklenir
    }

    return handleRequest(() => api.delete(url, { headers }))
  }

  // Diğer HTTP metotları için benzer fonksiyonlar ekleyebilirsiniz (put, delete, vb.)

  return { post, get, put, deleteRequest, error, isFetching, isFetchingAgain, loading }
}

export default useApiService
